export default "__VITE_ASSET__Dtj7O3_A__"